import { useQuery } from "@tanstack/react-query";
import { Agent } from "@/model";
import nluRepository from "@/repository/nluRepository";


export const useNluAgents = () => {
    return useQuery<Agent[]>({
        queryKey: ['nlu', 'agents'],
        queryFn: async () => {
            const data = await nluRepository.getNLUAgents();
            return data;
        }
    });
};
